import { gql } from "@apollo/client";

export const REFRESH_TOKEN = gql`
  query refresh($refresh_token: String!) {
    refresh(refresh_token: $refresh_token) {
      refresh_token
      access_token
      access_expiry
    }
  }
`;

export const GET_PROFILE_DETAILS = gql`
  query user {
    user {
      id
      uuid
      first_name
      last_name
      email
      phone_number
      image
      country_iso_alpha2
    }
  }
`;

export const GET_PAYOUT_PROFILE = gql`
  query PayoutProfile {
    payoutProfile {
      id
      user_id
      stripe_profiles {
        account_id
        status
      }
      flutterwave_profiles {
        currency_iso
        country_iso_alpha2
        subaccount_id
        subaccount_code
        status
        default
        account_number
        account_name
        bank_name
        bank_code
        disabled
      }
      paystack_profiles {
        currency_iso
        country_iso_alpha2
        subaccount_id
        subaccount_code
        status
        default
        account_number
        account_name
        bank_name
        bank_code
        disabled
      }
      created_at
      updated_at
    }
  }
`;
